import { useEffect } from "react";
import { TopLevelDialogNames } from "@/components/TopLevelDialogs";
import useFeatureFlags from "./useFeatureFlags";
import useDialog from "./useDialog";

const useFamilyMatchVideoTaskHandler = () => {
  const {
    flags: { familyMatchVideoPopUP },
  } = useFeatureFlags();
  const { openTopLevelDialog } = useDialog();

  useEffect(() => {
    if (familyMatchVideoPopUP) {
      openTopLevelDialog(TopLevelDialogNames.familyMatchVideo);
    }
  }, [familyMatchVideoPopUP]);
};

export default useFamilyMatchVideoTaskHandler;
